const aboutData = {
    mission: {
        title: 'Empowering Progress',
        subtitle: 'Turning Ideas Into Impact',
        content:
            "At SimpLiTechs, we ignite ideas and transform them into digital realities. Our mission is to empower businesses and people to thrive in a connected world—through creative technology, seamless experiences, and a relentless drive for progress.\n\nWe believe every challenge is an opportunity to innovate. From the first spark of inspiration to the final product launch, we walk alongside our clients, ensuring every solution is bold, beautiful, and built for the future.",
        illustration: '/innovation-animate.svg',
    },
    foundation: {
        title: 'Rooted in Excellence',
        subtitle: 'Built on Curiosity, Integrity, and Passion',
        content:
            'Our foundation is built on curiosity, integrity, and a passion for excellence. We blend deep expertise with a human touch, ensuring every solution is crafted with care and purpose.\n\nWe are relentless learners, always seeking new ways to grow and improve. Our roots run deep, but our vision is always forward—grounded in values, driven by results.',
        illustration: '/foundation.svg',
    },
    history: {
        title: 'Our Journey',
        subtitle: 'Milestones That Define Us',
        content: [
            {
                year: '2018',
                event: 'SimpLiTechs is founded by a small team of passionate technologists with a vision to simplify digital transformation.'
            },
            {
                year: '2019',
                event: 'First major client success: delivering a scalable SaaS platform that revolutionizes client operations.'
            },
            {
                year: '2021',
                event: 'Team grows to 20+ experts, expanding into new industries and launching our first AI-powered solution.'
            },
            {
                year: '2023',
                event: 'Recognized as a top innovator in digital services, with a global client base and a reputation for excellence.'
            }
        ],
        illustration: '/about_us/1.svg',
    },
    values: [
        {
            title: 'Invent Boldly',
            description:
                'We challenge the status quo, embracing new ideas and daring to innovate where others hesitate.'
        },
        {
            title: 'Craft with Care',
            description:
                'Every detail matters. We deliver quality and integrity in every line of code, every interaction, every time.'
        },
        {
            title: 'Client-First Mindset',
            description:
                'We listen deeply, collaborate closely, and build lasting partnerships that put your goals at the center.'
        },
        {
            title: 'Lead with Ethics',
            description:
                'Transparency, responsibility, and respect guide our actions—always.'
        },
        {
            title: 'Thrive Together',
            description:
                'We believe the best solutions come from diverse minds working as one. Teamwork is our superpower.'
        }
    ],
    valuesSection: {
        title: 'What Drives Us',
        subtitle: 'Our Heartbeat, Our Promise',
        content: 'Our values are the heartbeat of SimpLiTechs. They shape our culture, guide our decisions, and inspire us to create technology that makes a difference.\n\nWe don\'t just talk about values—we live them, every day, in every project, with every client. This is our promise to you.'
    },
    valuesIllustration: '/teamwork.svg',
    team: {
        title: 'Meet Our Team',
        subtitle: 'Diverse. Driven. Dedicated.',
        content: "Our team is a vibrant blend of creative thinkers, technical wizards, and passionate problem-solvers. We believe in the power of diversity and collaboration—each member brings unique strengths, and together, we achieve the extraordinary.\n\nFrom project managers to developers, designers to strategists, every SimpLiTechs team member is committed to your success.",
        illustration: '/teamwork.svg',
    },
    vision: {
        title: 'Shaping Tomorrow',
        subtitle: 'Inspiring Possibility, Empowering Change',
        content:
            'We envision a world where technology unlocks new possibilities for everyone. Our vision is to lead the way—creating digital solutions that inspire, empower, and elevate businesses and lives.\n\nWe are not just building software; we are shaping the future, one innovation at a time.',
        illustration: '/vision.svg',
    }
};

export default aboutData; 